import { motion } from "framer-motion";

export default function Skills() {
  const pilotage = [
    "Cadrage de besoin",
    "Analyse de problématiques métier",
    "Conduite d’entretiens",
    "Priorisation",
    "Coordination des parties prenantes",
  ];

  const ia = [
    "Identification de cas d’usage IA",
    "Prompting & LLM",
    "Agents IA (n8n)",
    "Automatisation de workflows",
    "RAG",
    "Intégration d’API IA",
  ];

  const dev = [
    "JavaScript (ES6+)",
    "React",
    "Node.js",
    "APIs REST",
    "MongoDB",
    "n8n",
  ];

  return (
    <section id="skills" className="skills-section">
      <motion.h2
        className="skills-title"
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, ease: "easeOut" }}
        viewport={{ once: false, amount: 0.5 }}
      >
        Compétences
      </motion.h2>

      <div className="skills-container">
        {/* CARD 1: Pilotage de projet & cadrage */}
        <motion.div
          className="skills-card"
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.1, ease: "easeOut" }}
          viewport={{ once: true, amount: 0.3 }}
        >
          <h3>Pilotage de projet & cadrage</h3>
          <ul className="skills-list">
            {pilotage.map((item, index) => (
              <motion.li
                key={index}
                initial={{ opacity: 0, x: -20 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.4, delay: 0.2 + index * 0.08, ease: "easeOut" }}
                viewport={{ once: true, amount: 0.3 }}
              >
                {item}
              </motion.li>
            ))}
          </ul>
        </motion.div>

        {/* CARD 2: IA & automatisation */}
        <motion.div
          className="skills-card"
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.2, ease: "easeOut" }}
          viewport={{ once: true, amount: 0.3 }}
        >
          <h3>IA & automatisation</h3>
          <ul className="skills-list">
            {ia.map((item, index) => (
              <motion.li
                key={index}
                initial={{ opacity: 0, x: -20 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.4, delay: 0.3 + index * 0.08, ease: "easeOut" }}
                viewport={{ once: true, amount: 0.3 }}
              >
                {item}
              </motion.li>
            ))}
          </ul>
        </motion.div>

        {/* CARD 3: Développement & intégration */}
        <motion.div
          className="skills-card"
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.3, ease: "easeOut" }}
          viewport={{ once: true, amount: 0.3 }}
        >
          <h3>Développement & intégration</h3>
          <ul className="skills-list">
            {dev.map((item, index) => (
              <motion.li
                key={index}
                initial={{ opacity: 0, x: -20 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.4, delay: 0.4 + index * 0.08, ease: "easeOut" }}
                viewport={{ once: true, amount: 0.3 }}
              >
                {item}
              </motion.li>
            ))}
          </ul>
        </motion.div>
      </div>
    </section>
  );
}
